import React from 'react'
import PropTypes from 'prop-types'
// import { makeStyles } from '@mui/styles'
import TextField from '@mui/material/TextField'
import { connect } from 'react-redux'
import Style from 'style-it'

// const mapStateToProps = (state, ownProps) => {
//   return {
//     themecolors: ownProps.themecolors || state.themeColors
//   }
// }

// const styles = theme => ({})

// class CustomTextField extends React.Component {
	const  CustomTextField =(props)=>{
//   render () {
    const { classes } = props

    const p = { ...props }

    delete p.dispatch

    return (
      <Style>
        {`
					.theme-label {
						margin-top: -4px;
						font-size: 16px;
						color: ${props.themecolors.textColor}
					}
					
					.theme-label-focused,
					.theme-label-shrink {
						margin-top: -14px;
						margin-left: -14px
					}
					.theme-label-focused {
						color: #fff;
					}
					.theme-textarea {
						font-size: 16px;
						padding: 0
					}
					.theme-label-error {
						color: ${props.themecolors.error}
					}
					.theme-notchedOutline legend {
						width: 0 !important;
					}
					.theme-notchedOutline {
						border-color:  ${props.themecolors&&props.themecolors.themeLightColor} !important;
						border-radius: 4px;
					}
					.theme-input-error .theme-notchedOutline {
						border-color:  ${props.themecolors.error} !important;
					}
					.theme-cssFocused .theme-notchedOutline {
						border-color:  ${props.themecolors&&props.themecolors.themeLightColor} !important;
					}
					.theme-input-select {
						border-color: ${props.themecolors&&props.themecolors.themeLightColor};
						color: ${props.themecolors.textColor};
						padding: 0;
						display: flex;
						height: auto
					}
					.theme-input {
						border-color: ${props.themecolors&&props.themecolors.themeLightColor};
						color: ${props.themecolors.textColor};
						font-size: 16px;
						padding: 5px 14px;
						min-height: 38px
					}
					.menu-list-icon {
						color: ${props.themecolors.textColor};
					}
					.custom-paper {
						background-color: ${props.themecolors&&props.themecolors.themeLightColor};
					}
				`}
        <div>
          <TextField
            margin='dense'
            {...p}
            variant='outlined'
            classes={classes}
            InputProps={{
              ...props.InputProps,
              classes: {
                root: 'theme-cssOutlinedInput',
                error: 'theme-input-error',
                input: props.multiline ? 'theme-textarea' : 'theme-input',
                focused: 'theme-cssFocused',
                notchedOutline: 'theme-notchedOutline'
              }
            }}
            SelectProps={{
              MenuProps: {
                classes: {
                  paper: 'custom-menu-paper'
                }
              },
              classes: {
                icon: 'menu-list-icon'
              }
            }}
            InputLabelProps={{
              ...props.InputLabelProps,
			shrink:true,
              classes: {
                root: 'theme-label',
                focused: 'theme-label-focused',
                shrink: 'theme-label-shrink',
                error: 'theme-label-error'
              }
            }}
          />
        </div>
      </Style>
    )
//   }
}

CustomTextField.propTypes = {
  classes: PropTypes.object.isRequired
}

// export default connect(mapStateToProps)( (styles)(CustomTextField))
const mapState = state => ({
	themes: state.themes 
 })
 
 const mapStateToProps = connect(mapState)
 export default mapStateToProps(CustomTextField);